import React, { useEffect, useState } from 'react';
import { Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'}`} data-id="element-60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-3 sm:py-4 flex items-center justify-end gap-2 sm:gap-4" data-id="element-61">
        <a href="https://www.instagram.com/dreambigslo/" target="_blank" rel="noopener noreferrer" className={`p-2 transition-colors duration-300 ${isScrolled ? 'text-neutral-700 hover:text-black' : 'text-white/80 hover:text-white'}`} aria-label="Instagram" data-id="element-62">
          <Instagram className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-63" />
        </a>
        <Link to="/zlati-arhiv" className={`px-4 sm:px-5 py-2 text-[10px] sm:text-xs font-medium uppercase tracking-widest transition-all duration-300 ${isScrolled ? 'text-neutral-800 border border-neutral-300 hover:border-neutral-800 hover:bg-neutral-100' : 'text-white border border-white/40 hover:bg-white hover:text-black'}`} data-id="element-64">
          Zlati arhiv
        </Link>
      </div>
    </header>;
}